export const version = "strings/5.5.0";
//# sourceMappingURL=_version.js.map